module.exports = __webpack_public_path__ + "assets/img/erw-wechat.8e3a99b4.png";